(function () {
          var section = document.currentScript.closest('.wagon-pre-bundle-collection');
          if (!section || section.dataset.bundleReady === 'true') return;
          section.dataset.bundleReady = 'true';

          var configEl = section.querySelector('[data-wagon-bundle-config]');
          if (!configEl) return;

	          var config = JSON.parse(configEl.textContent);
	          var products = config.products || {};
	          var inventory = config.inventory || {};
	          var currentBundle = null;
          var selections = {};
          var inlineSelections = {};

          var bundles = config.bundles || {};
          Object.keys(bundles).forEach(function (key) {
            bundles[key].product = bundles[key].product || key;
          });

          var bundleLayerCdn = 'https://cdn.shopify.com/s/files/1/0561/5891/2694/files/';
          var bundleLayerLabels = ['Midnight Black', 'Moss Green', 'Mocha', 'Sand'];
          var bundleLayerUrls = {
            canopy_left: [
              bundleLayerCdn + 'canopy-left-midnight-black.png',
              bundleLayerCdn + 'canopy-left-forest-green.png',
              bundleLayerCdn + 'canopy-left-mocha.png',
              bundleLayerCdn + 'canopy-left-sand.png'
            ],
            canopy_right: [
              bundleLayerCdn + 'canopy-right-midnight-black.png',
              bundleLayerCdn + 'canopy-right-forest-green.png',
              bundleLayerCdn + 'canopy-right-mocha.png',
              bundleLayerCdn + 'canopy-right-sand.png'
            ],
            basket_left: [
              bundleLayerCdn + 'basket-left-midnight-black.png',
              bundleLayerCdn + 'basket-left-forest-green.png',
              bundleLayerCdn + 'basket-left-mocha.png',
              bundleLayerCdn + 'basket-left-sand.png'
            ],
            basket_right: [
              bundleLayerCdn + 'basket-right-midnight-black.png',
              bundleLayerCdn + 'basket-right-forest-green.png',
              bundleLayerCdn + 'basket-right-mocha.png',
              bundleLayerCdn + 'basket-right-sand.png'
            ],
            snack: bundleLayerCdn + 'snack-tray-both.png',
            bugnet: {
              '0_0': bundleLayerCdn + 'Customize_bugnet_double_B_ac608867-9214-4153-b5fd-d19a02a80a7f.png',
              '1_1': bundleLayerCdn + 'Customize_bugnet_double_G.png',
              '2_2': bundleLayerCdn + 'Customize_bugnet_double_M.png',
              '3_3': bundleLayerCdn + 'Customize_bugnet_double_S.png'
            },
            rainfly: {
              '0_0': bundleLayerCdn + 'Customize_rainfly_double_B_a1aebe1f-e7d3-4bf6-a671-67c8a4b1f5bb.png',
              '1_1': bundleLayerCdn + 'Customize_rainfly_double_G.png',
              '2_2': bundleLayerCdn + 'Customize_rainfly_double_M.png',
              '3_3': bundleLayerCdn + 'Customize_rainfly_double_S.png'
            }
          };

          var modal = section.querySelector('[data-wagon-bundle-modal]');
	          var modalTitle = section.querySelector('[data-wagon-bundle-modal-title]');
	          var previewEl = section.querySelector('[data-wagon-bundle-preview]');
	          var choicesEl = section.querySelector('[data-wagon-bundle-choices]');
	          var modalPrice = section.querySelector('[data-wagon-bundle-modal-price]');
	          var modalBackorder = section.querySelector('[data-wagon-bundle-backorder]');
	          var errorEl = section.querySelector('[data-wagon-bundle-error]');
          var confirmButton = section.querySelector('[data-wagon-bundle-confirm]');
          var sliderEl = section.querySelector('[data-wagon-bundle-slider]');
          var navPills = Array.prototype.slice.call(document.querySelectorAll('[data-bundle-filter]'));
          var bundleCards = Array.prototype.slice.call(section.querySelectorAll('[data-bundle-key]'));
          var mobileBundleQuery = window.matchMedia ? window.matchMedia('(max-width: 860px)') : null;
          var headingEyebrow = section.querySelector('[data-bundle-heading-eyebrow]');
          var headingTitle = section.querySelector('[data-bundle-heading-title]');
          var headingText = section.querySelector('[data-bundle-heading-text]');
          var defaultHeader = {
            eyebrow: headingEyebrow ? headingEyebrow.innerHTML : '',
            title: headingTitle ? headingTitle.innerHTML : '',
            text: headingText ? headingText.innerHTML : ''
          };

          function initBundleSlider(attempt) {
            attempt = attempt || 0;
            if (!sliderEl || sliderEl.classList.contains('is-filtered')) return;

            if (!window.Swiper) {
              if (attempt < 30) {
                window.setTimeout(function () {
                  initBundleSlider(attempt + 1);
                }, 150);
              }
              return;
            }

            if (section.bundleSlider && typeof section.bundleSlider.destroy === 'function') {
              section.bundleSlider.destroy(true, true);
            }

            section.bundleSlider = new Swiper(sliderEl, {
              slidesPerView: 1,
              spaceBetween: 14,
              watchOverflow: true,
              navigation: {
                nextEl: section.querySelector('.bundle-slider-button.swiper-button-next'),
                prevEl: section.querySelector('.bundle-slider-button.swiper-button-prev')
              },
              pagination: {
                el: section.querySelector('.bundle-slider-pagination'),
                clickable: true
              },
              breakpoints: {
                768: {
                  slidesPerView: 3,
                  spaceBetween: 16
                },
                1200: {
                  slidesPerView: 5,
                  spaceBetween: 16
                }
              }
            });
          }

          function destroyBundleSlider() {
            if (section.bundleSlider && typeof section.bundleSlider.destroy === 'function') {
              section.bundleSlider.destroy(true, true);
              section.bundleSlider = null;
            }
          }

          function escapeHtml(value) {
            return String(value || '').replace(/[&<>"']/g, function (character) {
              return {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;'
              }[character];
            });
          }

          function splitHeading(value) {
            value = String(value || '').trim();
            if (!value) return '';
            if (mobileBundleQuery && mobileBundleQuery.matches) return escapeHtml(value);
            if (value.indexOf('\n') !== -1) return escapeHtml(value).replace(/\n/g, '<br>');
            var words = value.split(/\s+/);
            if (words.length < 4) return escapeHtml(value);
            var midpoint = Math.ceil(words.length / 2);
            var first = words.slice(0, midpoint).join(' ');
            var second = words.slice(midpoint).join(' ');
            return escapeHtml(first) + '<br>' + escapeHtml(second);
          }

          function updateSectionHeader(filterKey) {
            var isAll = filterKey === 'all';
            var bundle = bundles[filterKey];
            if (headingEyebrow) headingEyebrow.innerHTML = isAll || !bundle ? defaultHeader.eyebrow : escapeHtml(bundle.title || '');
            if (headingTitle) headingTitle.innerHTML = isAll || !bundle ? defaultHeader.title : splitHeading(bundle.heading || '');
            if (headingText) headingText.innerHTML = isAll || !bundle ? defaultHeader.text : '<p>' + escapeHtml(bundle.description || '') + '</p>';
          }

          function setCardButtonLabel(card, isAll) {
            var button = card && card.querySelector('[data-wagon-bundle-add]');
            if (!button) return;
            if (!button.dataset.addText) button.dataset.addText = button.textContent.trim();
            var bundleKey = button.dataset.wagonBundleAdd;
            var needsOptions = bundleOptionGroups(bundleKey).length > 0;
            button.textContent = isAll && needsOptions ? 'Choose colors' : button.dataset.addText;
            button.dataset.defaultText = button.textContent;
          }

          function setActiveNav(filterKey) {
            navPills.forEach(function (pill) {
              var isActive = (pill.dataset.bundleFilter || 'all') === filterKey;
              pill.classList.toggle('active', isActive);
              pill.setAttribute('aria-current', isActive ? 'true' : 'false');
            });
          }

          function setBundleFilter(filterKey, scrollTarget) {
            filterKey = filterKey || 'all';
            setActiveNav(filterKey);
            updateSectionHeader(filterKey);
            var isAll = filterKey === 'all';
            if (sliderEl) sliderEl.classList.toggle('is-filtered', !isAll);

            bundleCards.forEach(function (card) {
              var isMatch = isAll || card.dataset.bundleKey === filterKey;
              card.hidden = !isMatch;
              card.style.display = isMatch ? '' : 'none';
              card.classList.toggle('is-focused-bundle', !isAll && isMatch);
              setCardButtonLabel(card, isAll);
              if (isAll) {
                var inline = card.querySelector('[data-wagon-inline-options]');
                var inlineError = card.querySelector('[data-wagon-inline-error]');
                if (inline) inline.hidden = true;
                if (inlineError) inlineError.hidden = true;
              }
              applyCardCompositor(card, card.dataset.bundleKey, '');
            });

            if (isAll) {
              initBundleSlider();
            } else {
              destroyBundleSlider();
            }

            if (!isAll) {
              var selected = bundleCards.find(function (card) { return card.dataset.bundleKey === filterKey; });
              if (selected) renderInlineOptions(selected, filterKey);
            }
          }

          function initBundleFilters() {
            navPills.forEach(function (pill) {
              var filterKey = pill.dataset.bundleFilter || 'all';
              if (filterKey === 'build') return;
              if (filterKey === 'all' || bundleCards.some(function (card) { return card.dataset.bundleKey === filterKey; })) {
                pill.addEventListener('click', function (event) {
                  event.preventDefault();
                  setBundleFilter(filterKey);
                });
              }
            });
            var hasBaseBundle = bundleCards.some(function (card) { return card.dataset.bundleKey === 'base'; });
            setBundleFilter(mobileBundleQuery && mobileBundleQuery.matches && hasBaseBundle ? 'base' : 'all', false);

            if (mobileBundleQuery && typeof mobileBundleQuery.addEventListener === 'function') {
              mobileBundleQuery.addEventListener('change', function (event) {
                if (!event.matches) return;
                var allPill = navPills.find(function (pill) { return (pill.dataset.bundleFilter || 'all') === 'all'; });
                if (hasBaseBundle && allPill && allPill.classList.contains('active')) setBundleFilter('base', false);
              });
            }
          }

          function bundleProduct(bundle) {
            return bundle && products[bundle.product];
          }

	          function firstAvailableVariant(product) {
	            if (!product || !product.variants || !product.variants.length) return null;
	            return product.variants.find(function (variant) { return variant.available; }) || product.variants[0];
	          }

	          function withInventory(bundleKey, variant) {
	            if (!variant) return variant;
	            var bundleInventory = inventory[bundleKey] || {};
	            var variantInventory = bundleInventory[String(variant.id)];
	            return variantInventory ? Object.assign({}, variant, variantInventory) : variant;
	          }

	          function colorIndexFromValue(value) {
	            value = String(value || '').toLowerCase();
	            if (value.indexOf('black') !== -1 || value.indexOf('midnight') !== -1) return 0;
	            if (value.indexOf('green') !== -1 || value.indexOf('moss') !== -1 || value.indexOf('forest') !== -1) return 1;
	            if (value.indexOf('sand') !== -1) return 3;
	            return 2;
	          }

	          function normalizeOptionValue(value) {
	            var normalized = String(value || '').toLowerCase().trim();
	            if (normalized.indexOf('black') !== -1 || normalized.indexOf('midnight') !== -1) return 'black';
	            if (normalized.indexOf('green') !== -1 || normalized.indexOf('moss') !== -1 || normalized.indexOf('forest') !== -1) return 'green';
	            if (normalized.indexOf('mocha') !== -1) return 'mocha';
	            if (normalized.indexOf('sand') !== -1) return 'sand';
	            return normalized;
	          }

	          function optionValuesForSelection(bundleKey, selectionMap) {
	            selectionMap = selectionMap || {};
	            var values = [];
	            if (/everyday|daily|snack|loaded/.test(bundleKey)) {
	              values.push(selectionMap.canopy_all || colorLabelByIndex(2));
	            }
	            if (/daily|snack|loaded/.test(bundleKey)) {
	              values.push(selectionMap.basket_all || selectionMap.canopy_all || colorLabelByIndex(2));
	            }
	            return values.map(normalizeOptionValue);
	          }

          function setCardLayer(card, name, src) {
            var layer = card && card.querySelector('[data-bundle-card-layer="' + name + '"]');
            if (!layer) return;
            if (src) {
              layer.src = src;
              layer.hidden = false;
            } else {
              layer.removeAttribute('src');
              layer.hidden = true;
            }
          }

          function setModalLayer(name, src) {
            var layer = previewEl && previewEl.querySelector('[data-bundle-modal-layer="' + name + '"]');
            if (!layer) return;
            if (src) {
              layer.src = src;
              layer.hidden = false;
            } else {
              layer.removeAttribute('src');
              layer.hidden = true;
            }
          }

          function cardUsesCompositor(bundleKey) {
            return /everyday|daily|snack|loaded/.test(bundleKey || '');
          }

          function resetCardLayers(card) {
            ['basket_left', 'basket_right', 'canopy_left', 'canopy_right', 'snack', 'bugnet', 'rainfly'].forEach(function (name) {
              setCardLayer(card, name, '');
            });
          }

          function resetModalLayers() {
            ['basket_left', 'basket_right', 'canopy_left', 'canopy_right', 'snack', 'bugnet', 'rainfly'].forEach(function (name) {
              setModalLayer(name, '');
            });
          }

          function applyCardCompositor(card, bundleKey, colorValue) {
            var compositor = card && card.querySelector('[data-bundle-card-compositor]');
            var staticImage = card && card.querySelector('[data-bundle-static-image]');
            var shouldUse = !!(card && compositor && card.classList.contains('is-focused-bundle') && cardUsesCompositor(bundleKey));

            if (compositor) compositor.hidden = !shouldUse;
            if (staticImage) staticImage.hidden = shouldUse;
            resetCardLayers(card);
            if (!shouldUse) return;

            var canopyIndex = colorIndexFromValue(colorValue && colorValue.canopy ? colorValue.canopy : colorValue);
            var basketIndex = colorIndexFromValue(colorValue && colorValue.basket ? colorValue.basket : colorValue);
            setCardLayer(card, 'canopy_left', bundleLayerUrls.canopy_left[canopyIndex]);
            setCardLayer(card, 'canopy_right', bundleLayerUrls.canopy_right[canopyIndex]);

            if (/daily|snack/.test(bundleKey)) {
              setCardLayer(card, 'basket_left', bundleLayerUrls.basket_left[basketIndex]);
            }

            if (bundleKey === 'loaded') {
              var weatherKey = canopyIndex + '_' + canopyIndex;
              setCardLayer(card, 'basket_left', bundleLayerUrls.basket_left[basketIndex]);
              setCardLayer(card, 'basket_right', bundleLayerUrls.basket_right[basketIndex]);
              setCardLayer(card, 'bugnet', bundleLayerUrls.bugnet[weatherKey]);
              setCardLayer(card, 'rainfly', bundleLayerUrls.rainfly[weatherKey]);
            }

            if (/snack|loaded/.test(bundleKey)) setCardLayer(card, 'snack', bundleLayerUrls.snack);
          }

          function bundleOptionGroups(bundleKey) {
            var groups = [];
            if (/everyday|daily|snack|loaded/.test(bundleKey || '')) {
              groups.push({ key: 'canopy_all', title: 'Choose canopy color', property: 'Canopy Color' });
            }
            if (/daily|snack|loaded/.test(bundleKey || '')) {
              groups.push({ key: 'basket_all', title: 'Choose basket color', property: 'Basket Color' });
            }
            return groups;
          }

          function colorLabelByIndex(index) {
            return bundleLayerLabels[index] || bundleLayerLabels[2];
          }

          function defaultColorIndex(bundleKey, groupKey) {
            inlineSelections[bundleKey] = inlineSelections[bundleKey] || {};
            var current = inlineSelections[bundleKey][groupKey];
            if (current) return colorIndexFromValue(current);
            inlineSelections[bundleKey][groupKey] = colorLabelByIndex(2);
            return 2;
          }

          function setInlineSelection(bundleKey, groupKey, value) {
            inlineSelections[bundleKey] = inlineSelections[bundleKey] || {};
            inlineSelections[bundleKey][groupKey] = value;
          }

          function colorDotClass(index) {
            if (index === 0) return 'is-black';
            if (index === 1) return 'is-green';
            if (index === 3) return 'is-sand';
            return 'is-mocha';
          }

          function applyCardCompositorFromSelections(card, bundleKey) {
            var selectionMap = inlineSelections[bundleKey] || {};
            var canopyColor = selectionMap.canopy_all || colorLabelByIndex(defaultColorIndex(bundleKey, 'canopy_all'));
            var basketColor = selectionMap.basket_all || canopyColor;
            applyCardCompositor(card, bundleKey, {
              canopy: canopyColor,
              basket: basketColor
            });
          }

	          function renderInlineOptions(card, bundleKey) {
	            if (!card) return;
	            var container = card.querySelector('[data-wagon-inline-options]');
	            var backorder = card.querySelector('[data-wagon-inline-backorder]');
	            var error = card.querySelector('[data-wagon-inline-error]');
	            var groups = bundleOptionGroups(bundleKey);
	            if (backorder) {
	              backorder.hidden = true;
	              backorder.textContent = '';
	            }
	            if (error) {
	              error.hidden = true;
	              error.textContent = '';
            }
            if (!container) return;
            container.innerHTML = '';
            if (!groups.length) {
              applyCardCompositor(card, bundleKey, '');
              container.hidden = true;
              return;
            }

            groups.forEach(function (groupConfig) {
              var currentIndex = defaultColorIndex(bundleKey, groupConfig.key);
              var group = document.createElement('div');
              group.className = 'inline-bundle-options__group';
              group.innerHTML = '<div class="inline-bundle-options__head"><strong>' + groupConfig.title + '</strong></div><div class="inline-bundle-options__choices"></div>';
              var choices = group.querySelector('.inline-bundle-options__choices');

              [2, 3, 1, 0].forEach(function (index) {
                var value = colorLabelByIndex(index);
                var button = document.createElement('button');
                button.type = 'button';
                button.className = 'inline-bundle-options__choice';
                button.dataset.optionValue = value;
                button.setAttribute('aria-pressed', index === currentIndex ? 'true' : 'false');
                if (index === currentIndex) button.classList.add('is-selected');
                button.innerHTML = '<span class="inline-bundle-options__dot"></span><span>' + value + '</span>';
                var dot = button.querySelector('.inline-bundle-options__dot');
                if (index === 0) dot.classList.add('is-black');
                if (index === 1) dot.classList.add('is-green');
                if (index === 2) dot.classList.add('is-mocha');
                if (index === 3) dot.classList.add('is-sand');
                button.addEventListener('click', function () {
                  setInlineSelection(bundleKey, groupConfig.key, value);
                  renderInlineOptions(card, bundleKey);
                });
                choices.appendChild(button);
              });

              container.appendChild(group);
            });

	            applyCardCompositorFromSelections(card, bundleKey);
	            updateCardBackorder(card, bundleKey);
	            container.hidden = false;
	          }

          function showCardError(button, message) {
            var card = button && button.closest ? button.closest('[data-bundle-key]') : null;
            var error = card && card.querySelector('[data-wagon-inline-error]');
            if (error) {
              error.textContent = message;
              error.hidden = false;
              return;
            }
            showError(message);
          }

          function clearCardError(button) {
            var card = button && button.closest ? button.closest('[data-bundle-key]') : null;
            var error = card && card.querySelector('[data-wagon-inline-error]');
            if (error) {
              error.textContent = '';
              error.hidden = true;
            }
          }

	          function updatePreview() {
            if (!previewEl || !currentBundle) return;
            var bundleKey = currentBundle.product;
            if (!cardUsesCompositor(bundleKey)) {
              previewEl.classList.remove('is-visible');
              resetModalLayers();
              return;
            }

            var canopyIndex = colorIndexFromValue(selections.canopy_all || colorLabelByIndex(2));
            var basketIndex = colorIndexFromValue(selections.basket_all || selections.canopy_all || colorLabelByIndex(2));
            resetModalLayers();
            setModalLayer('canopy_left', bundleLayerUrls.canopy_left[canopyIndex]);
            setModalLayer('canopy_right', bundleLayerUrls.canopy_right[canopyIndex]);

            if (/daily|snack/.test(bundleKey)) {
              setModalLayer('basket_left', bundleLayerUrls.basket_left[basketIndex]);
            }

            if (bundleKey === 'loaded') {
              var weatherKey = canopyIndex + '_' + canopyIndex;
              setModalLayer('basket_left', bundleLayerUrls.basket_left[basketIndex]);
              setModalLayer('basket_right', bundleLayerUrls.basket_right[basketIndex]);
              setModalLayer('bugnet', bundleLayerUrls.bugnet[weatherKey]);
              setModalLayer('rainfly', bundleLayerUrls.rainfly[weatherKey]);
            }

            if (/snack|loaded/.test(bundleKey)) setModalLayer('snack', bundleLayerUrls.snack);
            previewEl.classList.add('is-visible');
          }

	          function updateModalPrice(bundleKey) {
	            if (!modalPrice) return;
	            var card = bundleCards.find(function (bundleCard) {
	              return bundleCard.dataset.bundleKey === bundleKey;
	            });
	            var price = card && card.querySelector('.price-row');
	            modalPrice.innerHTML = price ? price.innerHTML : '';
	            modalPrice.hidden = !price;
	          }

	          function variantTitle(variant) {
	            if (!variant) return '';
	            return String(variant.title || '').indexOf('Default') === -1 ? variant.title : '';
	          }

	          function isBackorderedVariant(variant) {
	            if (!variant || !variant.available) return false;
	            if (!variant.inventory_management) return false;
	            return Number(variant.inventory_quantity || 0) < 1;
	          }

	          function backorderMessage(product, variant) {
	            var title = product && product.title ? product.title : 'This bundle';
	            var optionTitle = variantTitle(variant);
	            return title + (optionTitle ? ' - ' + optionTitle : '') + ' is backordered and will ship as soon as it is back in stock.';
	          }

	          function updateBackorderElement(element, product, variant) {
	            if (!element) return;
	            if (isBackorderedVariant(variant)) {
	              element.textContent = backorderMessage(product, variant);
	              element.hidden = false;
	            } else {
	              element.textContent = '';
	              element.hidden = true;
	            }
	          }

	          function updateCardBackorder(card, bundleKey) {
	            if (!card) return;
	            var bundle = bundles[bundleKey];
	            var product = bundleProduct(bundle);
	            var selectionMap = inlineSelections[bundleKey] || selections;
	            var variant = selectedVariant(bundle, selectionMap, bundleKey);
	            updateBackorderElement(card.querySelector('[data-wagon-inline-backorder]'), product, variant);
	          }

	          function updateModalBackorder() {
	            if (!currentBundle) return;
	            var product = bundleProduct(currentBundle);
	            var variant = selectedVariant(currentBundle, selections, currentBundle.product);
	            updateBackorderElement(modalBackorder, product, variant);
	          }

	          function missingProducts(bundle) {
            var product = bundleProduct(bundle);
            return !product || !product.variants || !product.variants.length;
          }

          function showError(message) {
            if (!errorEl) return;
            if (modal && !modal.classList.contains('is-open')) {
	              currentBundle = null;
	              selections = {};
	              modalTitle.textContent = 'Bundle setup needed';
	              if (previewEl) previewEl.classList.remove('is-visible');
	              resetModalLayers();
	              if (modalBackorder) modalBackorder.hidden = true;
	              if (modalPrice) modalPrice.hidden = true;
	              choicesEl.innerHTML = '';
              modal.classList.add('is-open');
              modal.setAttribute('aria-hidden', 'false');
            }
            errorEl.textContent = message;
            errorEl.classList.add('is-visible');
          }

          function clearError() {
            if (!errorEl) return;
            errorEl.textContent = '';
            errorEl.classList.remove('is-visible');
          }

          function openModal(bundleKey) {
            currentBundle = bundles[bundleKey];
            selections = Object.assign({}, inlineSelections[bundleKey] || {});
            var groups = bundleOptionGroups(bundleKey);
            clearError();
            modalTitle.textContent = currentBundle.title;
            choicesEl.innerHTML = '';
            updateModalPrice(bundleKey);

            groups.forEach(function (groupConfig) {
              var currentIndex = selections[groupConfig.key] ? colorIndexFromValue(selections[groupConfig.key]) : defaultColorIndex(bundleKey, groupConfig.key);
              selections[groupConfig.key] = colorLabelByIndex(currentIndex);
              var group = document.createElement('div');
              group.className = 'bundle-choice';
              group.dataset.bundleGroup = groupConfig.key;
              group.innerHTML = '<div class="bundle-choice__label">' + groupConfig.title + '</div><div class="bundle-choice__options"></div>';
              var optionsEl = group.querySelector('.bundle-choice__options');

              [2, 3, 1, 0].forEach(function (index) {
                var value = colorLabelByIndex(index);
                var valueButton = document.createElement('button');
                valueButton.type = 'button';
                valueButton.className = 'bundle-choice__option';
                valueButton.innerHTML = '<span class="bundle-choice__dot ' + colorDotClass(index) + '"></span><span>' + value + '</span>';
                valueButton.dataset.optionValue = value;
                valueButton.setAttribute('aria-pressed', index === currentIndex ? 'true' : 'false');
                if (index === currentIndex) valueButton.classList.add('is-selected');
                valueButton.addEventListener('click', function () {
                  group.querySelectorAll('.bundle-choice__option').forEach(function (button) {
                    button.classList.remove('is-selected');
                    button.setAttribute('aria-pressed', 'false');
                  });
                  valueButton.classList.add('is-selected');
                  valueButton.setAttribute('aria-pressed', 'true');
	                  selections[groupConfig.key] = value;
	                  updatePreview();
	                  updateModalBackorder();
	                  clearError();
	                });
                optionsEl.appendChild(valueButton);
              });

              choicesEl.appendChild(group);
            });

	            updatePreview();
	            updateModalBackorder();
	            modal.classList.add('is-open');
	            modal.setAttribute('aria-hidden', 'false');
	          }

          function closeModal() {
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
	            currentBundle = null;
	            if (previewEl) previewEl.classList.remove('is-visible');
	            resetModalLayers();
	            if (modalBackorder) {
	              modalBackorder.textContent = '';
	              modalBackorder.hidden = true;
	            }
	            clearError();
	          }

	          function selectedVariant(bundle, selectionMap, bundleKey) {
	            var product = bundleProduct(bundle);
	            if (!product || !product.variants || !product.variants.length) return null;

	            var activeSelections = selectionMap || selections;
	            if (bundleKey === 'base') return withInventory(bundleKey, firstAvailableVariant(product));

	            var expectedOptions = optionValuesForSelection(bundleKey, activeSelections);
	            if (!expectedOptions.length) return withInventory(bundleKey, firstAvailableVariant(product));

	            var matchedVariant = product.variants.find(function (variant) {
	              if (!variant.available || !variant.options) return false;
	              return expectedOptions.every(function (expectedValue, index) {
	                return normalizeOptionValue(variant.options[index]) === expectedValue;
	              });
	            }) || firstAvailableVariant(product);
	            return withInventory(bundleKey, matchedVariant);
	          }

          function setButtonLoading(button, loading) {
            if (!button) return;
            if (!button.dataset.defaultText) button.dataset.defaultText = button.textContent;
            button.disabled = loading;
            button.classList.toggle('is-loading', loading);
            button.textContent = loading ? 'Adding...' : button.dataset.defaultText;
          }

          function addBundle(bundle, button, bundleKey) {
            if (missingProducts(bundle)) {
              showCardError(button, 'Please choose the bundle product in this section settings before adding.');
              return Promise.resolve();
            }

            var selectionMap = button === confirmButton ? selections : (inlineSelections[bundleKey] || selections);
            var variant = selectedVariant(bundle, selectionMap, bundleKey);
            if (!variant) {
              showCardError(button, 'No available variant matches the selected options.');
              return Promise.resolve();
            }

            clearCardError(button);
            setButtonLoading(button, true);

	            var item = { id: variant.id, quantity: 1 };

            return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ items: [item] })
            }).then(function (response) {
              if (!response.ok) {
                return response.json().then(function (data) {
                  throw new Error(data.description || data.message || 'Could not add this bundle to cart.');
                });
              }
              document.dispatchEvent(new CustomEvent('theme:cartchanged', {
                bubbles: true,
                cancelable: false,
                detail: { openDrawer: true }
              }));
              if (button === confirmButton && modal && modal.classList.contains('is-open')) closeModal();
            }).catch(function (error) {
              showCardError(button, error.message || 'Could not add this bundle to cart.');
            }).finally(function () {
              setButtonLoading(button, false);
            });
          }

          section.querySelectorAll('[data-wagon-bundle-add]').forEach(function (button) {
            button.addEventListener('click', function () {
              var bundleKey = button.dataset.wagonBundleAdd;
              var bundle = bundles[bundleKey];
              if (!bundle) return;
              clearError();

              if (missingProducts(bundle)) {
                showCardError(button, 'Please choose the bundle product in this section settings before adding.');
                return;
              }

              var card = button.closest('[data-bundle-key]');
              var wasFocused = card && card.classList.contains('is-focused-bundle');
              var groups = bundleOptionGroups(bundleKey);
              if (groups.length) {
                if (!wasFocused) {
                  openModal(bundleKey);
                  return;
                }
                renderInlineOptions(card, bundleKey);
              }

              addBundle(bundle, button, bundleKey);
            });
          });

          section.querySelectorAll('[data-wagon-bundle-close]').forEach(function (button) {
            button.addEventListener('click', closeModal);
          });

          confirmButton.addEventListener('click', function () {
            if (!currentBundle) return;
            var required = bundleOptionGroups(currentBundle.product).filter(function (groupConfig) {
              return !selections[groupConfig.key];
            });
            if (required.length) {
              showError('Please choose each bundle color before adding.');
              return;
            }
            addBundle(currentBundle, confirmButton, currentBundle && currentBundle.product);
          });

          document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && modal.classList.contains('is-open')) {
              closeModal();
            }
          });
          initBundleFilters();
        })();
